<template>
  <div class="p-4">
    <button

      :class="'btn ' + (counter > 10 ? 'btn-danger' : 'btn-warning') "
      @click="myCounter()"
    >
      Push the button!
    </button>
    <div class="mt-2">
      {{ counter }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return { counter: 0 };
  },
  methods: {
    myCounter() {
      this.counter += 1;
    },
  },
};
</script>
)
